import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';

export const API_CACHE_HEADER = 'X-Api-Cache';

@Injectable()
export class ApiCacheInterceptor implements HttpInterceptor {
    private cache = new Map<string, HttpResponse<any>>();

    constructor() {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const useCachedResponse = request.method === 'GET' && request.headers.has(API_CACHE_HEADER);
        if (!useCachedResponse) {
            return next.handle(request);
        }

        const cachedResponse = this.cache.get(request.urlWithParams);
        if (cachedResponse) {
            return of(cachedResponse.clone());
        }

        return next.handle(request).pipe(
            tap((response) => {
                if (response instanceof HttpResponse) {
                    this.cache.set(request.urlWithParams, response.clone());
                }
            })
        );
    }
}
